import Breadcrumbs from 'core/components/common/Breadcrumbs';
import { useLinks } from 'core/components/linksContext';
import { container, pageHeader } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';

const Expcalendar: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
    const links = useLinks();

    return (
        <>
            <div className={classes.header}>
                <h1>Календарь экспираций 2022</h1>
            </div>
            <div className={classes.container}>
                <Breadcrumbs
                    contrast={false}
                    items={[
                        { href: links.home.url(), title: 'Главная' },
                        { href: links.servicePage.url(), title: 'Сервисы инвестора' },
                        { title: 'Календарь экспираций' },
                    ]}
                />
                <p className={classes.text}>Календарь экспираций полезен тем, кто торгует фьючерсами и опционами.</p>
                <p className={classes.text}>
                    За последние пять лет Московская Биржа пересмотрела подход к определению дат экспираций
                    инструментов, и следить за ними стало нереально. В век, когда даже бабушки звонят внукам по видео
                    связи, а в каждой кофейне сидит три-четыре стартапера, отмечать даты на бумажном календаре стыдно.
                    Красный Циркуль тоже так подумал и сделал интерактивный календарь экспираций. Календарь
                    показывает все экспирации на 2022 год. Можно выбрать фьючерсы или опционы. У опционов можно выбрать
                    частоту экспирации: квартал, месяц, неделя. Можно поставить фильтр по инструменту и смотреть только
                    на Индекс РТС.
                </p>
                <p className={classes.text}>
                    Если у вас есть предложения, как улучшить календарь, пусть даже самые сумасшедшие, то пишите нам
                    на&nbsp;
                    <a href="mailto:info@red-circule.com">info@red-circule.com</a>. Мы передадим ваши идеи команде
                    разработчиков.
                </p>

                <iframe title="expcalendar" src="/expcalendar/2022.html" frameBorder="0" width="100%" height="1800px" />
            </div>
        </>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        header: {
            ...pageHeader(theme),
        },
        container: {
            ...container(theme),
        },
        text: {
            fontSize: 0.9 + 'rem',
        },
    });

export default injectSheet(styles)(Expcalendar);
